import { Button, Col, Descriptions, Input, Modal, Row, Select, Table, Tabs, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { ExportOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { ExportKPIPdf } from '../../Utils/exportKPIPdf';

function Kpi() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [division, setDivision] = useState([]);
    const [divisionValue, setDivisionValue] = useState('');
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    const titlePage = 'Employee KPI Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: "title",
        },
        {
            title: 'Employee Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => record.users?.users_code || "-",
        },
        {
            title: 'Employee Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.users?.name || "-",
        },
        {
            title: 'Division',
            dataIndex: 'division',
            key: "division",
            render: (text, record) => record.division?.name || "-",
        },
        {
            title: 'Max KPI Value',
            dataIndex: 'kpi_value_max',
            key: "kpi_value_max",
        },
        {
            title: 'Min KPI Value',
            dataIndex: 'kpi_value_min',
            key: "kpi_value_min",
        },
        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: "created_at",
            render: (text, record) => record.created_at ? moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') : "-",
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Button type="primary" onClick={() => openModal('detail', record)}>
                    <b>Detail</b>
                </Button>
            ),
        },
    ];

    const taskColumns = [
        {
            title: "Type",
            dataIndex: "type",
            key: "type",
            render: (text, record) => record.is_maximal ? <Tag color='blue'>Maximal</Tag> : <Tag color='cyan'>Minimal</Tag>
        },
        {
            title: "Performance Area",
            dataIndex: "perfomance_area",
            key: "perfomance_area",
            render: (text, record) => record.task.perfomance_area,
        },
        {
            title: "Key Performance Indicators",
            dataIndex: "perfomance_indicators",
            key: "perfomance_indicators",
            render: (text, record) => record.task.perfomance_indicators,
        },
        {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
            render: (text, record) => record.task.weight,
        },
        {
            title: "Target",
            dataIndex: "target",
            key: "target",
            render: (text, record) => record.task.target,
        },
        {
            title: "Actual",
            dataIndex: "actual",
            key: "actual",
        },
        {
            title: "Score",
            dataIndex: "score",
            key: "score",
        },
        {
            title: "Final Score",
            dataIndex: "final_score",
            key: "final_score",
        },
    ];

    useEffect(() => {
        getApi("GET", `/kpi?search=${search}&division=${divisionValue}&page=${page.pagination.current}`, 'kpi');
        getApi("GET", '/division?nopage=true', 'division');
    }, [JSON.stringify(page)]);

    const getApi = (method, url, type) => {
        setLoading(true);

        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'kpi':
                        setData(res.data.data);
                        setPage(prev => ({
                            ...prev,
                            pagination: {
                                ...prev.pagination,
                                total: res.data.total_data
                            }
                        }));
                        break;
                    case 'division':
                        const divOptions = res.data.data.map(item => ({
                            value: item.division_id,
                            label: item.name,
                        }));
                        setDivision(divOptions);
                        break;
                    default:
                        break;
                }
            }
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const openModal = (type, data) => {
        setdataModal(data);
        setIsModalVisible(true);
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = () => {
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    const DetailModal = ({ isVisible, onClose, detailData }) => (
        <Modal
            title="KPI Detail"
            open={isVisible}
            onCancel={onClose}
            footer={null}
            centered
            width={1000}
        >
            <Button onClick={() => ExportKPIPdf(detailData)} icon={<ExportOutlined />}>Export PDF</Button>
            <Tabs
                items={[
                    {
                        key: "1",
                        label: "General Information",
                        children: (
                            <Descriptions column={1} size='small' bordered>
                                <Descriptions.Item label="Title">{detailData?.title || "-"}</Descriptions.Item>
                                <Descriptions.Item label="Description">{detailData?.desc || "-"}</Descriptions.Item>
                                <Descriptions.Item label="Max KPI Value">{detailData?.kpi_value_max || "-"}</Descriptions.Item>
                                <Descriptions.Item label="Min KPI Value">{detailData?.kpi_value_min || "-"}</Descriptions.Item>
                            </Descriptions>
                        ),
                    },
                    {
                        key: "2",
                        label: "Task List",
                        children: (
                            <Table
                                dataSource={detailData?.kpi_task || []}
                                columns={taskColumns}
                                pagination={false}
                                rowKey={(record, index) => index}
                                bordered
                            />
                        ),
                    },
                    {
                        key: "3",
                        label: "Additional Notes",
                        children: (
                            <p>{detailData?.notes || "No additional notes"}</p>
                        ),
                    },
                ]}
            />
        </Modal>
    );

    return (
        <div style={{ padding: '20px' }}>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            <h3 style={{ marginBottom: '20px', fontSize: '24px' }}>Employee KPI</h3>

            <Row gutter={16} style={{ marginBottom: '20px' }}>
                <Col span={5}>
                    <Select
                        showSearch
                        placeholder="Select Division"
                        optionFilterProp="children"
                        style={{ width: '100%' }}
                        filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                        filterSort={(a, b) => a.label.localeCompare(b.label)}
                        options={division}
                        onChange={(e) => setDivisionValue(e)}
                    />
                </Col>
                <Col span={5}>
                    <Input
                        placeholder="Search"
                        allowClear
                        size="middle"
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col span={2}>
                    <Button type="primary" size="middle" onClick={searchData}>
                        <b>Search</b>
                    </Button>
                </Col>
                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {/* Future Add Button */}
                </Col>
            </Row>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                scroll={{ x: '100%' }}
                style={{ marginTop: '20px' }}
            />

            <DetailModal
                isVisible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                detailData={dataModal}
            />
        </div>
    );
}

export default Kpi;